

import * as React from 'react';
interface OwnProps {
}

const NotFoundPage: React.SFC<OwnProps> = (props: OwnProps) => {
  return (
    <div>
      ページ指定が誤っています。
    </div>
  );
}
export default NotFoundPage;




// WEBPACK FOOTER //
// ./src/components/NotFoundPage.tsx